// extracted by mini-css-extract-plugin
export default {"container":"_2Z_kAsVJF3KsvX5eZpPVbI","text":"_1PQokDGL37wVqLwR-9CtE_","button":"_10vWZTuIpOeoca34ixficI"};